export default __webpack_public_path__ + "static/media/microsoft-logo.a8fb743d.svg";